import { queryClient, apiRequest } from "../lib/queryClient";
const uploadKey = "upload";
export function useFileUpload() {
  const fileUpload = async (formData) => {
    const response = await apiRequest("/file/upload", {
      method: "POST",
      body: formData,
    });
    queryClient.invalidateQueries({ queryKey: [uploadKey] });
    return response;
  };

  const fileDelete = async (url) => {
    const response = await apiRequest(`/file/delete?url=${url}`, {
      method: "DELETE",
    });
    return response;
  };

  return {
    fileUpload,
    fileDelete,
  };
}
